<template>
  <div class="relative-div">
    <div class="iframe-container">
      <iframe :src="`/${$route.meta.url}`" frameborder="0"></iframe>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style>
.relative-div {
  display: relative;
}

.iframe-container {
  position: absolute;
  top: 56px;
  left: 0;
  right: 0;
  bottom: 0;
}

iframe {
  display: block;
  width: 100%;
  height: 100%;
  border: none;
}
</style>
